import { Link } from "react-router-dom";
import { Sparkles, ArrowRight, Inbox } from "lucide-react";

/* ──────────────────────────────────────────────────────────────────────────
   HubModeNotice — a friendly inline notice rendered at the top of pages
   that are designed for connected suppliers, when the buyer is in Hub
   mode (no active supplier). Uses STABLE LAYOUT — the page still renders
   below; this is just a contextual prompt that explains why things are
   empty + offers a one-click path to the equivalent Hub flow.
   ────────────────────────────────────────────────────────────────────── */
export default function HubModeNotice({
  page,                       // human label used in copy ("Orders", "Catalog", …)
  hubAlternative = "PO Inbox",// where to send the user instead
  hubAlternativeHref = "/buyer/po-inbox",
  description,                // optional override for the body copy
}) {
  return (
    <div className="rounded-2xl border border-violet-200 bg-violet-50/70 p-5 flex items-start gap-4" data-testid="hub-mode-notice">
      <div className="w-10 h-10 rounded-full bg-violet-100 grid place-items-center shrink-0">
        <Inbox className="w-5 h-5 text-violet-700"/>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-[10px] mono uppercase tracking-[0.18em] text-violet-700/80">Hub mode</span>
          <Sparkles className="w-3 h-3 text-violet-700/80"/>
        </div>
        <div className="display text-lg mt-1 leading-tight">{page} unlock once you connect a supplier</div>
        <p className="text-sm text-foreground/65 mt-1.5 max-w-2xl">
          {description || `${page} is built for live sync with verqo-connected suppliers. Until then, you can run the equivalent flow off-platform.`}
        </p>
      </div>
      <Link
        to={hubAlternativeHref}
        data-testid="hub-mode-cta"
        className="rounded-full bg-foreground text-background px-4 h-9 inline-flex items-center text-sm hover:bg-foreground/90 shrink-0"
      >
        {hubAlternative} <ArrowRight className="w-4 h-4 ml-1.5"/>
      </Link>
    </div>
  );
}
